import { render, staticRenderFns } from "./VsLoaderSpinner.vue?vue&type=template&id=0a8fa95e&"
var script = {}
import style0 from "../../../assets/css/loader.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports